import React from 'react';
import { Button, Badge, Card } from './ui';
import { FileText, Zap, ShieldCheck, Lock, CreditCard, Star, XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-3 pb-10 md:pt-4 md:pb-16 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-12" data-mp="38vkigfrwlpto">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-13" data-mp="3dxtddhoc71yf"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14" data-mp="33yawja3q3wal">
        <div className="inline-flex items-center gap-2 mb-2" data-id="element-15" data-mp="2q6nxx3mb6bon">
          <span className="text-2xl" data-id="element-16" data-mp="2q41hsflcqnut">🤖</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-17" data-mp="2u6y4oihxd64k">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-6xl font-black text-white mb-2 tracking-tight text-[26px] leading-[1.15]" data-id="element-18" data-mp="2gaav9g8scnhr">
          LA IA YA ESTÁ CAMBIANDO EL MERCADO.
          <br data-id="element-19" data-mp="2mnse34jzu7vn" />
          <span className="text-brand-400 text-glow" data-id="element-20" data-mp="2mnad5umdz5he">
            ¿VOS ESTÁS PREPARADO?
          </span>
        </h1>

        <div className="relative mt-1 mb-2 flex justify-center" data-id="element-21" data-mp="2hruyx1kgv7kg">
          <div className="absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="2vo8iqhch3l23"></div>
          <img src="https://cdn.magicpatterns.com/uploads/nLNrY7KVgCEjsvMyEwnVrH/mockup_final_.png" alt="Megapack Recursos Digitales — caja con los 6 tomos y bonos del sistema de IA profesional" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="2qqylifiue53p" />
        </div>

        <p className="md:text-xl text-slate-300 mb-1 font-medium max-w-3xl mx-auto text-[16px]" data-id="element-24" data-mp="1k9bgg5ra2zcs">
          Megapack Recursos Digitales — Combo Completo
        </p>

        <p className="text-slate-400 max-w-xl mx-auto text-[14px] mt-[2px] mb-[10px] leading-snug" data-id="element-25" data-mp="3fdsyx0hhdhs2">
          Mientras otros siguen aprendiendo IA, vos ya podés usarla para crear,
          automatizar y vender todos los días.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-4 overflow-x-auto" data-id="element-26" data-mp="3p4nn4aeaerg5">
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="3u2p850v9x0u9">
            <FileText className="w-4 h-4 mr-2 text-emerald-400" data-id="element-28" data-mp="3u4ifyjhmhr3u" /> 100% Digital
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-29" data-mp="2wgruphvr3lp6">
            <Zap className="w-4 h-4 mr-2 text-amber-400" data-id="element-30" data-mp="31cyqihufngte" /> Acceso inmediato
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-31" data-mp="36cldvk3z6dfx">
            <span className="mr-2" data-id="element-32" data-mp="36ext3picm9pa">🤖</span> 6 Tomos + 5 Bonos
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-33" data-mp="3afriknbfvwka">
          <Button size="md" className="w-full md:w-auto group" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-34" data-mp="lndqzriwijpc">
            <span className="mr-2 text-lg group-hover:scale-110 transition-transform" data-id="element-35" data-mp="2a82te5bz9biu">
              🤖
            </span>
            QUIERO MI MEGAPACK RECURSOS DIGITALES AHORA
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-36" data-mp="21c3omrjzp88q" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-37" data-mp="1wd0qlr2fg2a9">
            <span className="flex items-center" data-id="element-38" data-mp="1rde4st8j9dpu">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-39" data-mp="1mfm9rqcldbhf" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-40" data-mp="1iflvq6ten2aw">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-41" data-mp="1dg93f6jrl30x" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-42" data-mp="3cstlvl6fqpq7">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-43" data-mp="3csl8ls6ehieh" /> Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-44" data-mp="24jme9835vh79">
      <div className="max-w-6xl mx-auto px-4" data-id="element-45" data-mp="29ifpetuz6w49">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-46" data-mp="29g39sncowxud">
          <div data-id="element-47" data-mp="1vkr5bo8qft09">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-48" data-mp="20h97cgcohd8w">+1.200</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-49" data-mp="20jlxvhwi4vxk">
              personas ya operando
            </p>
          </div>
          <div data-id="element-50" data-mp="1qjv119kgy4ub">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-51" data-mp="1qkd70xwxnxff">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="1cs6urmwwial9">
              Tomos listos
            </p>
          </div>
          <div data-id="element-53" data-mp="1gujunuoyvea4">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-54" data-mp="1gu1q8as5htr4">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-55" data-mp="12thajnhj8e1u">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-56" data-mp="17s2adlsvgvpr">
            <p className="text-3xl font-bold text-white mb-1 flex items-center justify-center gap-1" data-id="element-57" data-mp="17uohxlfrjb7z">
              4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-58" data-mp="j7yx5s4307ur" />
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-59" data-mp="ja1u6w3nj18z">
              calificación
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-60" data-mp="t5vfb3vfs32d">
          <Card className="bg-slate-900" data-id="element-61" data-mp="t8hpzcdmiyot">
            <div className="flex gap-1 mb-4" data-id="element-62" data-mp="1754ldapxhgsm">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-63" data-mp="127l8of8vpc2s" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-64" data-mp="1gxk7mk89crjb">
              "Pensé que era otro curso de humo. En 24 horas cerré mi primer
              cliente de diseño de logos usando el Tomo 3. No lo podía creer."
            </p>
            <div className="flex items-center gap-3" data-id="element-65" data-mp="1lvc5duvl37vf">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-66" data-mp="1lspp96umnk1l">
                MG
              </div>
              <div data-id="element-67" data-mp="1xy4zupqu4yb0">
                <p className="font-bold text-white" data-id="element-68" data-mp="1xxd6zmomheof">Mariana G.</p>
                <p className="text-xs text-slate-500" data-id="element-69" data-mp="22vwx7za91cml">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-70" data-mp="27nomm6ho5cb5">
            <div className="flex gap-1 mb-4" data-id="element-71" data-mp="2boibb22xqv53">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-72" data-mp="2bqunszpxcdar" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-73" data-mp="2ln7gpvdnan4g">
              "El Tomo de Ventas Doradas me enseñó a cerrar servicios por
              primera vez. Antes no sabía ni cómo arrancar la conversación con
              un cliente."
            </p>
            <div className="flex items-center gap-3" data-id="element-74" data-mp="w7ge7ofk36rk">
              <div className="w-10 h-10 rounded-full bg-emerald-900 flex items-center justify-center text-emerald-400 font-bold" data-id="element-75" data-mp="w800fhc8ohbe">
                LP
              </div>
              <div data-id="element-76" data-mp="34q89f9a07jok">
                <p className="font-bold text-white" data-id="element-77" data-mp="34pq6jtsu677o">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-78" data-mp="30p654e18chfq">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-79" data-mp="2vro02yqc2md0">
            <div className="flex gap-1 mb-4" data-id="element-80" data-mp="2vorxuy7gdbir">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-81" data-mp="3serfrj9htme0" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-82" data-mp="3jew0p3cth78p">
              "El Tomo de Escalada Real vale cada peso. El sistema de prompts me
              resolvió la semana laboral completa desde el primer día."
            </p>
            <div className="flex items-center gap-3" data-id="element-83" data-mp="27yxmym6p1x15">
              <div className="w-10 h-10 rounded-full bg-blue-900 flex items-center justify-center text-blue-400 font-bold" data-id="element-84" data-mp="231nz3ayydtff">
                RM
              </div>
              <div data-id="element-85" data-mp="bxvwumq6swb5">
                <p className="font-bold text-white" data-id="element-86" data-mp="byf499i7o2ax">Roberto M.</p>
                <p className="text-xs text-slate-500" data-id="element-87" data-mp="bvszfhmpg0we">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-88" data-mp="21j35oun6ige">
      <div className="max-w-3xl mx-auto" data-id="element-89" data-mp="pp0nizbkue9c">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-90" data-mp="pq2aa11ygp6w">
          Mientras dudás, otros ya están cobrando con IA.
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-91" data-mp="g09094hgoi4r">
          Querés avanzar. Querés dejar de depender de un solo ingreso. Pero
          terminás cada domingo mirando la pantalla, saltando de tutorial en
          tutorial y llegando al lunes exactamente donde estabas. No te falta
          capacidad: te falta un sistema que te diga qué hacer primero.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-92" data-mp="2y4i8s8fo0j4g">
          No es falta de ganas. Es falta de un sistema.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-93" data-mp="2t5xc2izmghkr">
          <ul className="space-y-3" data-id="element-94" data-mp="37u1urmyoct3j">
            {['Domingo a la noche mirando la pantalla sin saber qué herramienta usar primero', 'Acumulás información de videos y cursos que nunca llegás a aplicar en la práctica', 'Siempre el mismo trabajo manual porque no tenés nada automatizado ni listo para entregar', 'Probás herramientas de IA sin criterio y sin resultados que duren más de dos días', 'Clientes que no aparecen, vos sin energía y la misma rutina de siempre otra vez', 'Fin de semana agotado, lunes arrancás el mismo ciclo exactamente igual que el anterior'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-95" data-mp="3vlfkrm9csclc" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-96" data-mp="3vn0kdqaiylq2" />
                <span className="text-slate-300 text-lg" data-id="element-97" data-mp="42wgdk6glw6o">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-98" data-mp="3rgs20dnh0173">
          Esta puede ser la última semana que te pasa esto.
        </h3>
      </div>
    </section>;
}